module.exports = ":host {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start; }\n  :host > * + * {\n    margin-left: 12px; }\n  @media (max-width: 768px) {\n    :host .quarter {\n      width: 115px; }\n    :host .type {\n      width: 72px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/map/map-controls/map-controls.component.scss
// module id = ./src/app/map/map-controls/map-controls.component.scss
// module chunks = main